<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8"
                 :sm="24">
            <a-form-item label="菜单名称">
              <a-input v-model="query.menuName"
                       placeholder="请输入菜单名"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8"
                 :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择"
                        default-value
                        v-model="query.status">
                <a-select-option value>全部</a-select-option>
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="2">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8"
                 :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="addOrUpdateHandle()"
                        v-action:add>新增</a-button>
              <a-button type="danger"
                        style="margin-left: 8px"
                        @click="deleteSelectRow()"
                        v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id"
             :row-selection="{selectedRowKeys: this.selectedRows,onChange: onSelectChange }"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
             :data-source="list"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="false">
      <a-tag color="blue"
             slot="type"
             slot-scope="text">{{ text | typeFilter }}</a-tag>
      <a-tag color="blue"
             slot="status"
             slot-scope="text">{{ text | statusFilter }}</a-tag>
      <span slot="createTime"
            slot-scope="text">{{ text | moment }}</span>
      <span slot="action"
            slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)"
           v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作"
             style="top: 20px;"
             :width="800"
             v-model="addOrUpdateVisible"
             @ok="handleOk"
             @cancel="handleCancel">
      <a-form class="tenant-form"
              :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="菜单名称"
                     hasFeedback>
          <a-input placeholder="菜单名称"
                   v-decorator="['menuName',{ rules: [{ required: true, message: '请输入菜单名称' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="菜单编码"
                     hasFeedback>
          <a-input placeholder="菜单编码"
                   v-decorator="['menuCode',{ rules: [{ required: true, message: '请输入登录密码' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="上级菜单">
          <a-tree-select :replace-fields="{title: 'menuName', key: 'id', value: 'id' }"
                         :tree-data="filterMenuTreeData"
                         v-decorator="['pid',{
                           initialValue:0
                         }]"
                         style="width: 100%"
                         :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                         placeholder="请选择上级菜单"
                         tree-default-expand-all>
            <!-- <span v-if='placeholder.pid==0' slot="placeholder" slot-scope="placeholder" style="color:red">一级菜单</span> -->
            <a-tree-select-node key="0"
                                value="0">
              一级菜单
            </a-tree-select-node>
          </a-tree-select>
          <a-button type="link"
                    @click="getMenuTree">
            <a-icon type="reload" />
          </a-button>
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="类型">
          <a-select placeholder="请选择"
                    default-value
                    v-decorator="['type',{ rules: [{ required: true, message: '请选择类型' }],initialValue:1 }]">
            <a-select-option :value="1">菜单</a-select-option>
            <a-select-option :value="2">按钮</a-select-option>
            <a-select-option :value="3">外链</a-select-option>
            <a-select-option :value="4">隐藏菜单</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="状态">
          <a-select placeholder="请选择"
                    default-value
                    v-decorator="['status',{ rules: [{ required: true, message: '请选择状态' }],initialValue:1 }]">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="操作权限"
                     hasFeedback>
          <a-input placeholder="操作权限,如add,edit,del,get,query"
                   v-decorator="['action']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="权限码"
                     hasFeedback>
          <a-input placeholder="权限码,如sys.menu.c"
                   v-decorator="['permissionCode']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="资源地址"
                     hasFeedback>
          <a-input v-decorator="['resourceUrl']"
                   placeholder="请输入资源地址" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'

const STATUS = {
  1: '正常',
  2: '禁用'
}

const TYPE = {
  1: '菜单',
  2: '按钮',
  3: '外链',
  4: '隐藏菜单'
}

const columns = [
  {
    title: '菜单名称',
    dataIndex: 'menuName'
  },
  {
    title: '菜单编码',
    dataIndex: 'menuCode'
  },
  {
    title: '类型',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '权限码',
    dataIndex: 'permissionCode'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'MenuList',
  data () {
    return {
      needPage: false,
      queryUrl: 'manager/menus/tree',
      addOrUpdateUrl: 'manager/menus',
      queryOneUrl: 'manager/menus',
      deleteUrl: 'manager/menus',
      query: {
        menuName: '',
        status: '',
        tenantId: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      menuTreeData: [] // 菜单树,不包含按钮
    }
  },
  computed: {
    filterMenuTreeData () {
      return [
        {
          id: '0',
          menuName: '一级菜单',
          children: this.filterTree(this.list, this.currentId)
        }
      ]
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    typeFilter (key) {
      return TYPE[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () {
    this.getMenuTree()
  },
  methods: {
    filterTree (list, id) {
      if (id && list) {
        let realList = []
        realList = list.map(l => {
          return {
            ...l,
            selectable: l.id != id,
            children: l.id == id ? this.filterTreetoSelected(l.children) : this.filterTree(l.children, id)
          }
        })
        return realList
      } else {
        return list
      }
    },
    filterTreetoSelected (list) {
      if (list) {
        return list.map(l => ({ ...l, selectable: false, children: this.filterTreetoSelected(l.children) }))
      } else {
        return list
      }
    },
    getMenuTree () {
      this.$http
        .get('/manager/menus/menu-tree')
        .then(res => {
          this.menuTreeData = res.data
          // this.menuTreeData.unshift({ menuName: '一级菜单', id: '0' })
        })
        .catch(() => { })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
